import { z } from "zod/v4";
import { ReturnProductSchema } from "../draft-return/draft-return-items";

export const getWarrantyEligibleProductsSchema = {
  name: "getWarrantyEligibleProducts" as const,
  input: z.object({}).nullish(),
  output: z.object({ eligibleProducts: z.array(ReturnProductSchema) }),
};
